"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var altMainHeaderStyles = styles_1.makeStyles(function () { return ({
    mainHeaderText: {
        width: '100%',
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    subHeaderText: {
        width: '100%',
        textAlign: 'center',
    },
    backText: {
        textTransform: 'unset',
    },
    navigationContainer: {
        marginBottom: 20,
    },
}); }, { name: 'Common_AltMainHeader' });
exports.default = altMainHeaderStyles;
